import axios, { AxiosResponse } from 'axios';
import { Question } from '../model/question.model';
import { User } from '../model/user.model';

export const getAccount = (): Promise<AxiosResponse<User>> => {
  return axios.get<User>(`/api/account`);
};
